<template>
    <div class="external-form-shell">
        <div class="external-form-header">
            <img src="@/assets/pura_logo.png" alt="Purapura Whetu" />
        </div>

        <div class="external-form-content">
            <q-inner-loading :showing="loading" label="Loading form…" />

            <q-card v-if="error" flat bordered class="q-pa-lg text-center">
                <q-icon name="o_link_off" size="48px" color="grey-7" />
                <h5 class="q-my-md">This form link is unavailable</h5>
                <p class="text-grey-8 q-mb-none">{{ error }}</p>
            </q-card>

            <q-card v-else-if="submitted" flat bordered class="q-pa-xl text-center">
                <q-icon name="o_check_circle" size="56px" color="positive" />
                <h4 class="q-my-md">Thank you</h4>
                <p class="text-body1 q-mb-none">Your form has been submitted successfully.</p>
            </q-card>

            <template v-else-if="invitation">
                <q-banner rounded class="bg-blue-1 text-grey-9 q-mb-md">
                    This secure form link expires {{ formatDate(invitation.expiresAt) }}.
                </q-banner>
                <DynamicFormRenderer
                    :form-id="invitation.form.id"
                    :subject="externalSubject"
                    :initial-structure="invitation.form"
                    :external-token="token"
                    @form-submitted="submitted = true"
                />
            </template>
        </div>
    </div>
</template>

<script>
import api from "@/services/api/api";
import DynamicFormRenderer from "@/components/DynamicFormComponents/DynamicFormRenderer.vue";

export default {
    name: "ExternalDynamicForm",
    components: { DynamicFormRenderer },
    data() {
        return {
            loading: true,
            invitation: null,
            error: null,
            submitted: false,
        };
    },
    computed: {
        token() {
            return String(this.$route.params.token || "");
        },
        externalSubject() {
            return {
                source: "external",
                id: null,
                name: this.invitation?.recipientName || "Client",
                email: null,
                phone: null,
            };
        },
    },
    async created() {
        try {
            const response = await api.forms.getExternalFormInvitation(this.token);
            this.invitation = response.data;
        } catch (error) {
            this.error = error.response?.data?.message || "The link may have expired or already been used.";
        } finally {
            this.loading = false;
        }
    },
    methods: {
        formatDate(value) {
            const date = new Date(value);
            return Number.isNaN(date.getTime())
                ? "soon"
                : date.toLocaleString("en-NZ", { dateStyle: "long", timeStyle: "short" });
        },
    },
};
</script>

<style scoped>
.external-form-shell {
    min-height: 100vh;
    background: #f5f7f7;
}

.external-form-header {
    display: flex;
    justify-content: center;
    padding: 24px;
    background: white;
    border-bottom: 1px solid #e0e0e0;
}

.external-form-header img {
    width: min(220px, 60vw);
    height: auto;
}

.external-form-content {
    position: relative;
    width: min(1000px, calc(100% - 32px));
    min-height: 240px;
    margin: 28px auto;
}
</style>
